import { Spacing } from "types/Spacing";

export const COLUMN_GAP: Spacing = "large";
export const COLUMN_ORDER = " minmax(10rem, 1fr) minmax(20rem, 10fr) minmax(10rem, 2fr) ";

export const FILTERS_ORDER_SETTINGS_KEY = "policyUsedByFiltersOrder";
